import { render, staticRenderFns } from "./ResultDetailSacrificeInRight.vue?vue&type=template&id=17159372&scoped=true&"
import script from "./ResultDetailSacrificeInRight.vue?vue&type=script&lang=js&"
export * from "./ResultDetailSacrificeInRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17159372",
  null
  
)

export default component.exports